<template>
    <div :class="['group-template', {'double-new-style': doubleNew}]">
        <div class="group-activity">
            <Header :title="modelTitle" @goMore="starHome" :showMore="list.length > 0" :tag-list="tagList" @changeTag="onChangeTag">
                <search-input placeholder="搜索协作组名称" 
                    style="width: 280px;"
                    @search-input="onSearch"
                    v-if="+fromTemplateId === 2"
                    isClear
                />
                <i class="split-line"></i>
            </Header>
            <ul class="group-activity-list" v-if="list.length">
                <li class="list-item" @click="toDetail(item.groupId)" v-for="item in list" :key="item.groupId">
                    <div class="list-item-link" v-link="linkUrl(item.groupId)">
                        <LazyImage class-name="avatar" :src="item.groupLogo" alt=""></LazyImage>
                        <p class="info">
                            <span class="main overflow-ellipsis" :title="item.groupName">{{item.groupName}}</span>
                            <span class="sub overflow-ellipsis" :title="`${roleName}：${item.managerCall}`">{{roleName + '：' + (item.managerCall || '')}}</span>
                        </p>
                    </div>
                </li>
            </ul>
            <no-data style="padding-top: 50px" v-else :info="`暂无${modelTitle || '协作组'}`" url="no-group@2x.png"/>
        </div>
        <div class="group-activity-right" v-if="!doubleNew">
             <Activation />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import LazyImage from '@/components/lazy-image/lazy-image.vue'
import Activation from './activation.vue'
import Header from '@/components/home-common-title/index.vue'
import NoData from '@/components/no-data.vue'
import { pageJump } from '@/global/location-transfer'
import { jumpHref } from '@/router/jumpHref.js';
import searchInput from '../common/search-input.vue';

const props = defineProps({
    modelTitle: {
        type: String,
        default: ''
    },
    tagList: {
        type: Array,
        default: () => {
            return []
        }
    },
    doubleNew: {
        type: Boolean,
        default: false
    },
    roleName: {
        type: String,
        default: '组长'
    },
    fromTemplateId: String
});

const list = ref([]);

const stages = ref([]);

const getList = function(){
    G_transmit('getOtherGroupList', {
        name: 'getOtherGroupList',
        data: {
            pageSize: props.doubleNew ? 8 : 9,
            pageIndex: 1,
            stages: stages.value
        }
    }).then(res => {
        list.value = res?.data?.rows || [];
    });
}

const starHome = function(){
    pageJump({name: 'groupIndex'})
}

// 跳转活动详情
function toDetail(id) {
    pageJump(jumpHref.group.detail(id), true);
}

function linkUrl(id){
    return {
        url: jumpHref.group.detail(id),
        className: 'link-item'
    }
}

const onChangeTag = (tag) => {
    stages.value = tag
    getList()
}

function onSearch(search) {
    pageJump({ name: 'groupSearch', query: { search } });
}

onMounted(() => {
    let tag = props.doubleNew ? [1204] : []
    onChangeTag(tag)
})
</script>

<style lang="scss" scoped>
.group-template {
    display: flex;
    .group-activity {
        flex: 820px 0 0;
        width: 820px;
    }
    .group-activity-right {
        width: 278px;
        margin-left: 102px;
    }
}
.group-activity-list{
    display: flex;
    padding: 30px 0 0 0;
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
    flex-wrap: wrap;
    margin-bottom: -30px;
    :deep(.avatar){
        width: 70px;
        height: 70px;
        margin-right: 12px;
        border-radius: 4px; 

        img {
           border-radius: 4px; 
        }
    }
    .list-item{
        display: flex;
        align-items: center;
        width: calc(33.3333% - 40px);
        margin-bottom: 30px;
        cursor: pointer;
        margin-right: 60px;
        
        &:nth-child(3n){
            margin-right: 0px;
        }

        &:hover {
            .info {
                color: var(--home-main-color) !important;
            }
        }
        .info{
            width: calc(100% - 120px);
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            color: var(--color-black);
            flex: 1;
            .main{
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 14px;
            }
            .sub{
                font-size: 14px;
            }
        }
    }
    :deep(.link-item){
        width:100%;
        .list-item-link{
            display: flex;
            align-items: center;
        }
    }
}

.double-new-style {
    .group-activity {
        flex: 1;
        width: 100%;
    }
    .group-activity-list{
        padding: 26px 0 0 0;
        :deep(.avatar){
            width: 80px;
            height: 80px;
            margin-right: 14px;
            border-radius: 5px; 

            img {
            border-radius: 5px; 
            }
        }
    }
    .list-item{
        display: flex;
        align-items: center;
        width: calc(25% - 66px);
        margin-right: 88px;
        &:nth-child(3n){
            margin-right: 88px;
        }
        &:nth-child(4n){
            margin-right: 0px;
        }
        .info{
            .main{
                margin-bottom: 22px;
            }
        }
    }
}
.split-line {
    width: 1px;
    height: 14px;
    background-color: var(--home-border-color);
    margin: 10px 10px 0 6px;
}
</style>
